module.exports = __webpack_public_path__ + "img/confirm-hen.f64f7450.png";